const Home = () => import('../views/home.vue')

export default [
  {
    path: '/page/home',
    component: Home,
    meta: { requiresAuth: true },
    name: 'page.home'
  }
]